// extracted by mini-css-extract-plugin
module.exports = {"container":"Pitch_container__cZgB1","pitch":"Pitch_pitch__0ntvJ","centerCircle":"Pitch_centerCircle__ndVwD","penaltyArea":"Pitch_penaltyArea__6sFNG"};